import { Col, Row } from "reactstrap";
import { FuseResult } from "fuse.js";
import { SearchEngineEntry } from "../search/SearchEngineEntry";
import { formatDateTimeString } from "../helper/formatDateTime";
import { SongBadges } from "../common/components/song/SongBadges";
import { LyricsPreview } from "../common/components/song/LyricsPreview";
import { CyItems } from "./CyItems";
import { useTranslation } from "react-i18next";

interface Props {
  songSearchResult: FuseResult<SearchEngineEntry> | SearchEngineEntry;
  showDetails: boolean;
  onlyFirstColumn?: boolean;
}

export function SongSummary({
  songSearchResult,
  showDetails,
  onlyFirstColumn = false,
}: Props) {
  const item =
    "item" in songSearchResult ? songSearchResult.item : songSearchResult;
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col xs={12} lg={8}>
          <span className="lead me-2" data-cy={CyItems.ItemTitle}>
            {item.title}
          </span>
          <small>{item.versionDescription}</small>
        </Col>
        {!onlyFirstColumn && (
          <>
            <Col lg={2}>
              <span className="d-lg-none">{t("items.created")} </span>
              {formatDateTimeString(item.createdAt)}
            </Col>
            <Col lg={2}>
              <span className="d-lg-none">{t("items.updated")} </span>
              {formatDateTimeString(item.updatedAt)}
            </Col>
          </>
        )}
      </Row>
      <Row>
        {showDetails && (
          <div>
            {<LyricsPreview songId={item.id} />}
            <SongBadges badgeProvider={item} />
          </div>
        )}
      </Row>
    </>
  );
}
